<script setup>
import { Header, Desc, Block, Light, Tickets, Btn, Plate,About } from '@/mock/618.js'
function toJump(url) {
  window.open(url)
}
</script>

<template>
  <div class="body">
    <img class="bodyHeader" :src="Header.pic" :alt="Header.alt" />
    <div class="wrap">
      <img class="wrapDesc" :src="Desc.pic" :alt="Desc.alt" />
      <img class="wrapBlock" :src="Block.pic" :alt="Block.alt" >
      <!-- <img class="wrapLight" :src="Light.pic" :alt="Light.alt" />
      <div class="wrapNav">
        <div class="wrapNavTitle">限量抢早鸟票</div>
        <div class="wrapNavLine"></div>
        <div class="wrapNavDesc">
          为回馈十年来新老朋友的支持，ISC在全网购物狂欢节之际奉献感恩钜惠，限量放送ISC
          2023早鸟票100张！锁定本年度最精彩安全盛宴，6月18日晚8点准时开抢！
        </div>
        <img class="wrapNavImg" src="https://p1.ssl.qhimg.com/t01f38a854c99beb09a.png" alt="" />
      </div> -->
      <img class="wrapNavPlate" :src="Plate.pic" :alt="Plate.alt" />
      <div class="wrapTik">
        <img
          class="wrapTikImg"
          v-for="item in Tickets"
          :key="item.id"
          :src="item.pic"
          :alt="item.alt"
          @click="toJump(item.url)"
        />
      </div>
      <!-- <img class="wrapTog" :src="Togther.pic" :alt="Togther.alt" /> -->
      <!-- <img class="wrapBtn" :src="Btn.pic" :alt="Btn.alt" @click="toJump(Btn.url)" /> -->
      <img
        class="wrapAbout"
        :src="About.pic"
        :alt="About.alt"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.body {
  width: 100%;
  text-align: center;
  background-color: #fff;
  &Header {
    width: 100%;
  }
}
.wrap {
  width: 100%;
  margin: auto;
  &Desc {
    display: inline-block;
    width: 300px;
    margin: 25px 0 0;
  }
  &Block {
    display: inline-block;
    width: 300px;
    margin: 37px 0;
  }
  &Light {
    width: 300px;
  }
  &NavPlate {
      width: 300px;
      margin: 0 0 12px;
    }
  // &Nav {
  //   margin: 45px 0 0px;
  //   &Img {
  //     width: 300px;
  //   }
  //   &Title {
  //     font-weight: bold;
  //     font-size: 11px;
  //     color: #0d0d0d;
  //     line-height: 12px;
  //   }
  //   &Line {
  //     width: 20px;
  //     height: 2px;
  //     background: #de2112;
  //     margin: 8px auto 25px;
  //   }
  //   &Plate {
  //     width: 300px;
  //     margin: 11px 0 12px;
  //   }
  //   &Desc {
  //     width: 300px;
  //     font-size: 7px;
  //     color: #0d0d0d;
  //     opacity: 0.8;
  //     line-height: 21px;
  //     margin: auto;
  //     text-align: left;
  //   }
  // }
  &Tik {
    width: 300px;
    margin: auto;
    &Img {
      display: inline-block;
      width: 100%;
      // height: 65px;
      cursor: pointer;
      margin-bottom: 4px;
    }
    &Img:last-child {
      margin-bottom: 0;
    }
  }
  &Tog {
    display: block;
    width: 300px;
    margin: 37px auto 45px;
  }
  &Btn {
    width: 300px;
    margin: 19px 0 61px;
  }
  &About {
    width: 300px;
    margin: 50px 0 61px;
  }
}
</style>
